import { Pagination } from 'antd';
import { inject, observer } from 'mobx-react';
import React, { Component } from 'react';
import { DEFAULT_PAGE, DEFAULT_PAGE_SIZE } from '../../constants/tables';
import { ContentListUrlParams } from '../../stores/contentListStore/contentListStoreModel';
import styles from './ContentsFooter.module.scss';
import { ContentFooterProps, InjectedProps } from './ContentsFooterModel';


@inject('contentListStore')
@observer
class ContentsFooter extends Component<ContentFooterProps> {
    get injected() {
        return this.props as InjectedProps;
    }

    onChangePage = (pageNumber: number) => {
        if (pageNumber !== DEFAULT_PAGE) {
            this.injected.contentListStore.searchParams.setUrlParam(
                ContentListUrlParams.byPage, pageNumber.toString()
            );
        } else {
            this.injected.contentListStore.searchParams.deleteUrlParam(
                ContentListUrlParams.byPage
            );
        }
    }

    onPaginationChangeSize = (current: number, pageSize: number) => {
        if (pageSize !== DEFAULT_PAGE_SIZE) {
            this.injected.contentListStore.searchParams.setUrlParam(
                ContentListUrlParams.bySize, pageSize.toString()
            );
        } else {
            this.injected.contentListStore.searchParams.setUrlParam(
                ContentListUrlParams.bySize, pageSize.toString()
            );
        }
    }

    render() {
        const { currentPage, currentSize } = this.props;
        const { total: totalCount } = this.injected.contentListStore.contentListData;
        return (
            <Pagination
                className={styles.ContentsFooterPagination}
                showSizeChanger={true}
                pageSize={currentSize}
                total={totalCount}
                current={currentPage}
                onChange={this.onChangePage}
                onShowSizeChange={this.onPaginationChangeSize}
            />
        );
    }
}

export default ContentsFooter;
